import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { map, Observable } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { ChangeNameComponent } from 'src/app/components/profile/config/change-name/change-name.component';
import { ChangePasswordComponent } from 'src/app/components/profile/config/change-password/change-password.component';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { CropperImageComponent } from 'src/app/components/bloques/cropper-image/cropper-image.component';
import { ApiBusinessService } from 'src/app/services/api-business.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BusinessService } from 'src/app/services/business.service';
import { PermissionService } from 'src/app/services/permission.service';
import { PlacesService } from 'src/app/services/places.service';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-info-profile',
  templateUrl: './info-profile.component.html',
  styleUrls: ['./info-profile.component.scss'],
})
export class InfoProfileComponent {
  user!: any;
  now: Date = new Date();
  functions: Observable<any> = new Observable();

  openPermission: boolean = true;
  permissionExtra: any[] = [];

  companyInfo: Observable<any> = new Observable();

  placesUser: any[] = [];
  rolesUser: any[] = [];

  imgControl: FormControl = new FormControl(null);
  changedImg: boolean = false;
  loadingPage: boolean = true;
  urlImages: string = AppSettings.MEDIA_URI + '/users_images/';

  constructor(
    private auth: AuthenticationService,
    private placesService: PlacesService,
    private permissionService: PermissionService,
    private dialog: MatDialog,
    private userService: UserService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.user = this.auth.getProfile();
    let business: any = localStorage.getItem('business');
    business = business ? JSON.parse(business) : null;
    if (
      business &&
      this.user.roles.find((role: any) => role.name == 'superadmin')
    ) {
      this.auth.getMyData().subscribe({
        next: (res) => {
          this.user = res;
          this.rolesUser = this.user.roles;

          if (this.user.image) {
            this.imgControl.setValue(this.urlImages + this.user.image);
          } else {
            this.imgControl.setValue('assets/img/image_default.png');
          }

          this.placesService.getPlacesByUser(this.user.id).subscribe({
            next: (res) => {
              this.placesUser = res.data.data?.filter(
                (place) => place.id_company == business.id,
              );
            },
          });

          // Mostrar solo superadmin (sin functions) cuando el usuario es superadmin
          this.rolesUser = [{ name: 'superadmin' }];
          this.loadingPage = false;
        },
      });
    } else {
      if (this.user.image) {
        this.imgControl.setValue(this.urlImages + this.user.image);
      } else {
        this.imgControl.setValue('assets/img/image_default.png');
      }
      this.loadingPage = false;

      this.auth.getMyData().subscribe({
        next: (res) => {
          this.placesUser = res.companies
            .filter((val) => val.id == business.id)
            .flatMap((company: any) => company.spaces);

          // Obtener todas las funciones de la empresa actual
          const allFunctions = res.companies
            .filter((val) => val.id == business.id)
            .flatMap((company: any) => company.functions);

          const functionRoles = allFunctions.map((funcion: any) => ({ name: funcion }));

          // Si el usuario es superadmin, mostrar solo ese rol sin functions
          const isSuperAdmin = this.user.roles?.find((role: any) => role.name === 'superadmin');
          this.rolesUser = isSuperAdmin
            ? [{ name: 'superadmin' }]
            : functionRoles;
        },
      });
    }
  }

  ngAfterViewInit(): void {}

  async onFileChange(event: any) {
    let files = event.target.files;

    if (files && files.length) {
      let file = files[0];

      // 1. Validar que sea una imagen
      if (!file.type.match('image.*')) {
        this.openInfoCard('Solo se permite utilizar imágenes.', false, true);
        event.target.value = '';
        return;
      }

      const maxSize = 10 * 1024 * 1024; // 10 MB

      // 2. Comprimir la imagen de forma segura
      try {
        file = await this.compressImage(file);
      } catch (e) {
        console.error('Error comprimiendo:', e);
      }

      // 3. Validar el peso final
      if (file.size > maxSize) {
        this.openInfoCard(
          'La imagen no puede ocupar <br> más de 10 MB.',
          false,
          true,
        );
        event.target.value = '';
        return;
      }

      // 4. Crear el evento falso para no romper el DOM ni el Cropper
      const fakeEvent = {
        target: {
          files: [file],
        },
      };

      const dialogRef = this.dialog.open(CropperImageComponent, {
        panelClass: 'info-dialog',
        disableClose: true,
        data: fakeEvent, // Pasamos el fakeEvent
      });

      dialogRef.afterClosed().subscribe((result) => {
        event.target.value = ''; // Limpiamos el input siempre al cerrar
        if (result) {
          this.imgControl.setValue(result.pathUrl);
          this.changedImg = true;

          // Tu lógica original intacta para guardar en base de datos
          this.userService
            .uploadFilePut({ image: result.object.base64 }, this.user.id)
            .subscribe({
              next: (res) => {
                // Actualizamos usuario con la respuesta del API
                if (res && res.success && res.message) {
                  const updatedUser = { ...this.user, ...res.message };

                  // Forzamos recarga de la imagen evitando caché del navegador
                  if (updatedUser.image) {
                    updatedUser.image = `${updatedUser.image}?v=${Date.now()}`;
                  }

                  this.user = updatedUser;
                  this.auth.setProfile(this.user);

                  // Actualizamos la vista previa
                  this.imgControl.setValue(this.urlImages + this.user.image);
                }

                this.openInfoCard(
                  'La imagen se ha actualizado correctamente',
                  false,
                  false,
                );
                this.changedImg = false;
              },
              error: (err) => {
                this.openInfoCard(
                  '¡Vaya! Ha ocurrido un error al intentar actualizar la imagen',
                  true,
                  false,
                );
                if (this.user.image) {
                  this.imgControl.setValue(this.urlImages + this.user.image);
                } else {
                  this.imgControl.setValue('assets/img/image_default.png');
                }
              },
            });
        }
      });
    }

    // Si el usuario cancela la ventana de archivos
    if (!event.target.files || event.target.files.length === 0) {
      if (this.user.image) {
        this.imgControl.setValue(this.urlImages + this.user.image);
      } else {
        this.imgControl.setValue('assets/img/image_default.png');
      }
    }
  }

  async compressImage(file: File): Promise<File> {
    return new Promise((resolve) => {
      // Si NO es una imagen estándar, devolvemos el original sin comprimir
      if (!file.type.match(/image\/(jpeg|png|webp)/)) {
        resolve(file);
        return;
      }

      const img = new Image();
      // Usamos ObjectURL para no saturar la memoria del navegador
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;

      img.onload = () => {
        URL.revokeObjectURL(objectUrl); // Limpiamos la memoria
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        const MAX_WIDTH = 1920;
        const MAX_HEIGHT = 1080;
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx?.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const compressedFile = new File([blob], file.name, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              resolve(compressedFile);
            } else {
              resolve(file);
            }
          },
          'image/jpeg',
          0.7,
        );
      };

      img.onerror = () => {
        // Evita bloqueos si la imagen está corrupta
        URL.revokeObjectURL(objectUrl);
        resolve(file);
      };
    });
  }

  saveImg() {
    //TODO: Falta en la api la llamada para subir imagen
    this.userService
      .uploadFilePut({ file: this.imgControl.value }, this.user.id)
      .subscribe({
        next: (res) => {
          // Mantener compatibilidad si se sigue usando este método
          if (res && res.success && res.message) {
            const updatedUser = { ...this.user, ...res.message };
            if (updatedUser.image) {
              updatedUser.image = `${updatedUser.image}?v=${Date.now()}`;
            }
            this.user = updatedUser;
            this.auth.setProfile(this.user);
            this.imgControl.setValue(this.urlImages + this.user.image);
          }

          this.openInfoCard(
            'La imagen se ha actualizado correctamente',
            false,
            false,
          );
          this.changedImg = false;
        },
        error: (err) => {
          this.openInfoCard(
            '¡Vaya! Ha ocurrido un error al intentar actualizar la imagen',
            true,
            false,
          );
          if (this.user.image) {
            this.imgControl.setValue(this.urlImages + this.user.image);
          } else {
            this.imgControl.setValue('assets/img/image_default.png');
          }
        },
      });
  }

  openInfoCard(
    msg: string,
    disabledClose: boolean = false,
    icon: boolean = true,
  ) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        icon: icon,
        text: msg,
        btnCancel: false,
      },
    });
  }

  openChangeName() {
    const dialogRef = this.dialog.open(ChangeNameComponent, {
      panelClass: 'info-dialog',
      data: {
        user: this.user,
      },
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res && res.status == 'changed') {
          this.openInfoCard(
            'Los cambios se han guardado correctamente',
            false,
            false,
          );
          this.user.name = res.name;
        }
        if (res && res.status == 'error') {
          this.openInfoCard('¡Vaya! Ha ocurrido un error.');
        }
      },
    });
  }

  goToPlace(place: any) {
    this.router.navigate([`panel-control/config/venues/info-venue/${place.id}`]);
  }

  private roleDescriptions: { [key: string]: string } = {
    'admin': 'Control total de la empresa: eventos, informes, pedidos, suscriptores y espacios.',
    'superadmin': 'Control global de la plataforma y gestión de todas las empresas.',
    'CREATE_EVENTS': 'Crear y gestionar eventos, bonos e informes.',
    'Gestor de eventos': 'Crear y gestionar eventos, bonos e informes.',
    'ACCESS_REPORTS': 'Ver informes y pedidos con datos económicos.',
    'Finanzas': 'Ver informes y pedidos con datos económicos.',
    'ACCESS_SALES': 'Acceso a taquilla, gestión de pedidos y consulta de informes.',
    'Ventas': 'Acceso a taquilla, gestión de pedidos y consulta de informes.',
    'ACCESS_MARKETING': 'Gestionar suscriptores y herramientas de comunicación.',
    'Marketing': 'Gestionar suscriptores y herramientas de comunicación.',
    'ACCESS_SUPPORT': 'Atención al cliente: suscriptores y pedidos.',
    'Soporte': 'Atención al cliente: suscriptores y pedidos.',
    'ACCESS_QR_APP': 'Validación de entradas mediante la app QRLok.',
    'QR APP': 'Validación de entradas mediante la app QRLok.',
    'ACCESS_CLOUD': 'Acceso completo al panel de la empresa.',
    'ACCOUNT_OWNER': 'Propietario de la cuenta con acceso total.',
    'ACCESS_EXTERN_EVENTS': 'Acceso a eventos externos y gestión de la organización.',
    'ACCESS_ADMIN': 'Administración avanzada: eventos, informes, pedidos y espacios.',
    'Administración': 'Control total de la empresa: eventos, informes, pedidos, suscriptores y espacios.',
    'ACCESS_MANAGER': 'Acceso a configuración básica y perfil.',
  };

  getRoleDescription(roleName: string): string {
    return this.roleDescriptions[roleName] ?? this.roleDescriptions[roleName?.toLowerCase()] ?? '';
  }

  logout() {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      disableClose: false,
      data: {
        icon: true,
        text: '¿Estás seguro de que quieres cerrar sesión?',
        btnCancel: true,
        showCloseBtn: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.auth.logout();
      }
    });
  }

  openChangePassword() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      panelClass: 'info-dialog',
      data: {
        user: this.user,
      },
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res == 'changed') {
          this.openInfoCard('Los cambios se han guardado correctamente');
        }
        if (res == 'error') {
          this.openInfoCard('¡Vaya! Ha ocurrido un error.');
        }
      },
    });
  }
}
